export const thTH = {
  translation: {
    common: {
      loading: 'กำลังดำเนินการ...',
      error: 'ข้อผิดพลาด',
      button: 'กลับไปหน้า Dashboard',
      goToDashboard: 'กลับไปหน้า Dashboard',
    },
    noPermission: {
      title: 'ไม่มีสิทธิ์เข้าถึง',
      description: 'คุณไม่มีสิทธิ์เข้าถึงหน้านี้.',
      goToDashboardDescription: 'คุณไม่มีสิทธิ์เข้าถึงหน้านี้. โปรดติดต่อผู้ดูแลระบบเพื่อขอสิทธิ์เข้าถึง.',
      goToDashboardButton: 'กลับไปหน้า Dashboard',
    },
    'Add Fulfillment': 'เพิ่มการดำเนินการ',
    'Input Your data': 'กรอกข้อมูลของคุณ',
    Name: 'ชื่อ',
    Select: 'เลือก',
    search: {
      placeholder: 'ค้นหา',
    },
    login: {
      title: 'เข้าสู่ระบบ กับ Xinchuan Auth',
      button: 'เข้าสู่ระบบ',
      success: 'เข้าสู่ระบบสำเร็จ',
      authCallback_authentication_failed: ' เข้าสู่ระบบการตรวจสอบสิทธิ์ การตรวจสอบสิทธิ์การโทรกลับล้มเหลว: {error}',
      authCallback_invalid_parameters: ' เข้าสู่ระบบการตรวจสอบสิทธิ์การโทรกลับพารามิเตอร์ที่ไม่ถูกต้อง',
      authCallback_invalid_state_parameter: ' เข้าสู่ระบบการตรวจสอบสิทธิ์ Callback พารามิเตอร์สถานะไม่ถูกต้อง',
      authCallback_failed: 'การเข้าสู่ระบบการตรวจสอบสิทธิ์การโทรกลับล้มเหลว',
      authCallback_success: 'เข้าสู่ระบบตรวจสอบความถูกต้องโทรกลับสำเร็จ',
      authCallback_completing_authentication: ' เข้าสู่ระบบการตรวจสอบสิทธิ์ Callback เสร็จสิ้นการตรวจสอบสิทธิ์',
      authCallback_redirecting: 'เข้าสู่ระบบการตรวจสอบสิทธิ์การโทรกลับเปลี่ยนเส้นทาง',
    },
    sidebar: {
      overview: 'ภาพรวม',
      operational: 'การดำเนินงาน',
      dashboard: 'หน้าแรก',
      fulfillment: 'จัดการการดำเนินการตามคำสั่งซื้อ',
      addFulfillment: 'เพิ่มการดำเนินการ',
      aggregator: 'จัดการตัวรวม',
      report: 'รายงาน',
      products: 'ผลิตภัณฑ์',
      wallet: 'ยอดเงินคงเหลือ',
      logout: 'ออกจากระบบ',
      product_group: 'กลุ่มผลิตภัณฑ์',
      product_management: 'จัดการผลิตภัณฑ์',
      manage_sku: 'จัดการ SKU',
      product_fee: 'ค่าธรรมเนียมสินค้า',
      voucherpin: 'Voucher PIN',
      voucher_pin_import: 'นำเข้า Voucher PIN',
      voucher_pin: 'Voucher PIN',
      orders: 'คำสั่งซื้อ',
      manage_orders: 'จัดการคำสั่งซื้อ',
    },
    pages: {
      wallet: 'จัดการยอดเงินคงเหลือ',
      report: 'ศูนย์รายงาน',
      product_group: 'กลุ่มผลิตภัณฑ์',
      product_management: 'จัดการผลิตภัณฑ์',
      manage_sku: 'จัดการ SKU',
      voucher_pin: 'Voucher PIN',
      orders: 'จัดการคำสั่งซื้อ',
    },
    orders: {
      title: 'จัดการคำสั่งซื้อ',
      searchPlaceholder: 'เลขที่ใบแจ้งหนี้, รหัสลูกค้า หรือรหัสการชำระเงิน',
      empty: 'ไม่มีคำสั่งซื้อ',
      columns: {
        identifier: 'เลขที่ใบแจ้งหนี้',
        createdAt: 'วันที่',
        status: 'สถานะ',
        paymentMethod: 'วิธีชำระเงิน',
        paymentId: 'รหัสการชำระเงิน',
        customer: 'ลูกค้า',
        quantity: 'จำนวน',
        purchase: 'ยอดซื้อ',
        totalFee: 'ค่าธรรมเนียมรวม',
        paymentFee: 'ค่าธรรมเนียมการชำระ',
        amount: 'ยอดที่ชำระ',
        expiresAt: 'หมดอายุ',
      },
      filters: {
        identifierPlaceholder: 'เลขที่ใบแจ้งหนี้แบบตรงทั้งหมด',
        customerPlaceholder: 'รหัสผู้ใช้ลูกค้า',
        paymentPlaceholder: 'รหัสการชำระเงิน',
        paymentMethodPlaceholder: 'รหัสวิธีชำระเงิน',
        amountFrom: 'จำนวนต่ำสุด',
        amountTo: 'จำนวนสูงสุด',
      },
      statuses: {
        waiting_for_payment: 'รอการชำระเงิน',
        paid: 'ชำระแล้ว',
        processing: 'กำลังดำเนินการ',
        pending: 'รอดำเนินการ',
        complete: 'เสร็จสิ้น',
        cancelled: 'ยกเลิก',
        expired: 'หมดอายุ',
      },
      lineStatuses: {
        pending: 'รอดำเนินการ',
        fulfilling: 'กำลังจัดส่ง',
        fulfilled: 'จัดส่งแล้ว',
        failed: 'ล้มเหลว',
      },
      paymentCreation: {
        not_started: 'ยังไม่เริ่ม',
        creating: 'กำลังสร้าง',
        created: 'สร้างแล้ว',
        unknown: 'ไม่ทราบ',
      },
      feeTypes: {
        product_fee: 'ค่าธรรมเนียมสินค้า',
        payment_fee: 'ค่าธรรมเนียมการชำระ',
      },
      fulfillmentErrors: {
        delivery_failed: 'จัดส่งไม่สำเร็จ',
        destination_invalid: 'ปลายทางไม่ถูกต้อง',
        reconciliation_required: 'ต้องตรวจสอบยอด',
      },
      overview: {
        title: 'รายละเอียดคำสั่งซื้อ',
        refresh: 'รีเฟรช',
        information: 'ข้อมูล',
        customer: 'รายละเอียดลูกค้า',
        payment: 'ข้อมูลการชำระเงิน',
        amounts: 'จำนวนเงิน',
        lines: 'รายการ',
        breakdown: 'รายละเอียดคำสั่งซื้อ',
        fees: 'ค่าธรรมเนียม',
        timeline: 'ประวัติสถานะ',
        identifier: 'เลขที่ใบแจ้งหนี้',
        copy: 'คัดลอกเลขที่ใบแจ้งหนี้',
        copied: 'คัดลอกเลขที่ใบแจ้งหนี้แล้ว',
        paymentMethodId: 'วิธีชำระเงิน',
        paymentId: 'รหัสการชำระเงิน',
        paymentCreation: 'การสร้างการชำระเงิน',
        expiresAt: 'หมดอายุ',
        currency: 'สกุลเงิน',
        customerId: 'รหัสลูกค้า',
        noCustomer: 'ไม่มีรหัสลูกค้า',
        purchase: 'ยอดซื้อ',
        totalFee: 'ค่าธรรมเนียมรวม',
        paymentFee: 'ค่าธรรมเนียมการชำระ',
        amount: 'ยอดที่ต้องชำระ',
        product: 'สินค้า',
        destination: 'ปลายทาง',
        quantity: 'จำนวน',
        unitPrice: 'ราคาต่อหน่วย',
        fulfillment: 'การจัดส่ง',
        reviewRequired: 'ต้องตรวจสอบ',
        feeType: 'ประเภท',
        feeName: 'ชื่อ',
        feeAmount: 'จำนวน',
        refundable: 'คืนเงินได้',
        yes: 'ใช่',
        no: 'ไม่',
        noLines: 'ไม่มีรายการ',
        noFees: 'ไม่มีค่าธรรมเนียม',
        noTimeline: 'ไม่มีประวัติสถานะ',
        paymentUrl: 'ลิงก์ชำระเงิน',
        instructions: 'คำแนะนำการชำระเงิน',
        notes: 'หมายเหตุ',
        addNote: 'เพิ่มหมายเหตุ',
        attach: 'แนบไฟล์',
        removeAttachment: 'ลบไฟล์แนบ',
        notePlaceholder: 'หมายเหตุภายใน',
        noteAdded: 'เพิ่มหมายเหตุแล้ว',
        noNotes: 'ไม่มีหมายเหตุ',
        loadingNotes: 'กำลังโหลดหมายเหตุ',
        moreNotes: 'หมายเหตุก่อนหน้า',
        attachments: 'ไฟล์แนบ',
        attachHint: 'แนบไฟล์โดยลาก วาง หรือคลิกที่นี่',
        fulfillmentDestination: 'ปลายทางการจัดส่ง',
        fulfillmentError: 'ข้อผิดพลาดการจัดส่ง',
      },
      rowActions: {
        expandRow: 'ขยายคำสั่งซื้อ',
        collapseRow: 'ย่อคำสั่งซื้อ',
      },
    },
    voucherPin: {
      title: 'จัดการรหัส PIN บัตรกำนัล',
      searchPlaceholder: 'ค้นหาคำนำหน้า PIN',
      empty: 'ไม่มี PIN',
      emptyNoFilter: 'เลือก SKU สถานะ หรือค้นหาเพื่อดูรหัส PIN',
      selectSku: 'เลือก SKU',
      selectStatus: 'สถานะ',
      register: 'ลงทะเบียนบัตรกำนัลใหม่',
      upload: 'อัปโหลดบัตรกำนัล',
      uploadHistory: 'ดูประวัติการอัปโหลด',
      filterByProduct: 'กรอง PIN ตามผลิตภัณฑ์',
      selectProvider: 'เลือกผู้ให้บริการ',
      selectProduct: 'เลือกผลิตภัณฑ์',
      codesTitle: 'รหัส PIN บัตรกำนัล',
      sold: 'ขายแล้ว',
      edit: 'แก้ไข',
      detail: {
        title: 'รายละเอียดผลิตภัณฑ์',
        view: 'ดูรายละเอียดผลิตภัณฑ์',
        productInfo: 'ข้อมูลผลิตภัณฑ์',
        stockInfo: 'การตั้งค่าสต็อก',
        skuId: 'รหัส SKU',
        code: 'รหัส',
        name: 'ชื่อ',
        pinFormat: 'รูปแบบ PIN',
        legacyProducts: 'ผลิตภัณฑ์เดิม',
        lowStock: 'เกณฑ์สต็อกต่ำ',
        restockDelay: 'ระยะเวลารอเติมสต็อก',
        disabled: 'ปิดใช้งาน',
        recallable: 'เรียกคืนได้',
        yes: 'ใช่',
        no: 'ไม่',
        copy: 'คัดลอก',
        unavailable: 'ไม่มีข้อมูล',
        expandRow: 'ขยายแถว',
        collapseRow: 'ย่อแถว',
      },
      columns: {
        code: 'รหัส',
        sku: 'SKU',
        batch: 'ชุด',
        status: 'สถานะ',
        cost: 'ต้นทุน',
        costMin: 'Min',
        costMax: 'Max',
        createdBy: 'ผู้สร้าง',
        createdAt: 'สร้างเมื่อ',
        action: 'การทำงาน',
        copied: 'คัดลอกแล้ว',
        revealing: 'กำลังโหลดรหัส...',
      },
      status: {
        available: 'พร้อมใช้',
        reserved: 'จองแล้ว',
        allocated: 'จัดสรรแล้ว',
        voided: 'ยกเลิกแล้ว',
      },
      form: {
        registerTitle: 'ลงทะเบียนบัตรกำนัลใหม่',
        uploadTitle: 'อัปโหลดบัตรกำนัล',
        editTitle: 'แก้ไขรหัส PIN บัตรกำนัล',
        product: 'ผลิตภัณฑ์',
        provider: 'ผู้ให้บริการ',
        pinCode: 'รหัส PIN',
        pinPlaceholder: 'ใส่รหัส PIN',
        histories: 'ประวัติ',
        noSubmissions: 'คุณยังไม่ได้ส่งรหัส PIN',
        submittedCount: 'ส่งแล้ว {{count}} รหัส',
        registerNotice:
          'ตรวจสอบว่ารหัสที่ใส่เป็นของ <b>{{product}}</b> จาก <b>{{provider}}</b>',
        uploadNotice:
          'ตรวจสอบว่าไฟล์ที่เลือกเป็นของ <b>{{product}}</b> จาก <b>{{provider}}</b>',
        price: 'ราคา: <b>{{price}}</b>',
        file: 'ไฟล์',
        costPrice: 'ราคาทุน',
        costInvalid: 'ราคาทุนต้องไม่เกินราคาสินค้า ({{price}})',
        template: 'เทมเพลต',
        templateHint: 'ดาวน์โหลดเทมเพลตได้<link>ที่นี่</link>',
        currentPin: 'PIN ปัจจุบัน',
        newPin: 'รหัส PIN ใหม่',
        confirmTitle: 'คุณแน่ใจหรือไม่?',
        confirmIntro: 'คุณกำลังจะเปลี่ยน PIN',
        from: 'จาก:',
        to: 'เป็น:',
        paste: 'วางรูปภาพ',
      },
    },
    Button: {
      Info: 'ข้อมูล',
      Success: 'สำเร็จ',
      Error: 'ข้อผิดพลาด',
      Warning: 'คำเตือน',
      Confirm: 'ยืนยัน',
    },
    fileUpload: {
      uploading: 'กำลังอัปโหลด',
      attach_files: 'แนบไฟล์โดยการลากและวาง วาง หรือคลิกที่นี่',
      errors: {
        file_too_large: 'ขนาดไฟล์ใหญ่เกินไป ขนาดไฟล์สูงสุดคือ {size}MB',
        max_files: 'อนุญาตให้มีไฟล์สูงสุด {max} ไฟล์ คุณเหลือช่องว่าง {remaining} ช่อง',
        invalid_content: 'เนื้อหาไฟล์ไม่ถูกต้อง โปรดอัปโหลดรูปภาพที่ถูกต้อง (JPEG, PNG หรือ SVG)',
        upload_failed: 'การอัปโหลดล้มเหลว โปรดลองอีกครั้ง',
      },
      success: 'อัปโหลดไฟล์สำเร็จแล้ว',
      errors_upload_failed: 'การอัปโหลดล้มเหลว โปรดลองอีกครั้ง',
    },
    imageUpload: {
      uploading: 'กำลังอัปโหลด',
      attach_files: 'แนบไฟล์โดยการลากและวาง วาง หรือคลิกที่นี่',
      addPhoto: 'เพิ่มรูปภาพ',
      main: 'หลัก',
      setAsMain: 'ตั้งเป็นรูปหลัก',
      success: 'อัปโหลดรูปภาพสำเร็จแล้ว',
      errors: {
        file_too_large: 'ขนาดไฟล์ใหญ่เกินไป ขนาดไฟล์สูงสุดคือ {size}MB',
        max_files: 'อนุญาตให้มีไฟล์สูงสุด {max} ไฟล์ คุณเหลือช่องว่าง {remaining} ช่อง',
        invalid_content: 'เนื้อหาไฟล์ไม่ถูกต้อง โปรดอัปโหลดรูปภาพที่ถูกต้อง (JPEG, PNG หรือ SVG)',
        upload_failed: 'การอัปโหลดล้มเหลว โปรดลองอีกครั้ง',
        not_image: 'โปรดเลือกไฟล์รูปภาพ',
      },
    },
    pagination: {
      prev: 'ก่อนหน้า',
      next: 'ถัดไป',
      prevPageAria: 'หน้าก่อนหน้า',
      nextPageAria: 'หน้าถัดไป',
    },
    table: {
      filterReset: 'รีเซ็ต',
    },
    ui: {
      cancel: 'ยกเลิก',
      imageCrop: {
        title: 'อัปโหลดรูปภาพ',
        save: 'บันทึก',
        invalid: 'อัปโหลดรูป JPG หรือ PNG ขนาดไม่เกิน {{max}} MB',
      },
      emptyState: {
        noData: 'ไม่มีข้อมูล',
      },
      chart: {
        noData: 'ไม่มีข้อมูลแผนภูมิ',
      },
      dateTimeRangeFilter: {
        startDate: 'วันเริ่มต้น',
        endDate: 'วันสิ้นสุด',
      },
      numberRangeFilter: {
        reset: 'รีเซ็ต',
        search: 'ค้นหา',
      },
      statusBadge: {
        available: 'พร้อมใช้งาน',
        unavailable: 'ไม่พร้อมใช้งาน',
        hidden: 'ซ่อน',
        disabled: 'ปิดใช้งาน',
        success: 'สำเร็จ',
        pending: 'รอดำเนินการ',
        failed: 'ล้มเหลว',
        refunded: 'คืนเงินแล้ว',
        uncertain: 'ไม่แน่นอน',
        processing: 'กำลังดำเนินการ',
      },
    },
    report: {
      selectSection: 'เลือกประเภทรายงานจากเมนู',
      category: 'หมวดหมู่รายงาน',
      fulfillment: {
        item: 'การดำเนินการ',
        title: 'รายการดำเนินการ',
        description: 'สร้างรายงานการจัดซื้อรายการสำหรับช่วงเวลาที่เลือก',
        supplier: 'ซัพพลายเออร์',
        supplierPlaceholder: 'เลือกซัพพลายเออร์',
        period: 'ช่วงเวลา',
        export: 'ส่งออก',
      },
    },
    fulfillment: {
      empty: 'ไม่มีรายการดำเนินการที่ตรงกับตัวกรองของคุณ',
      columns: {
        transactionId: 'รหัสธุรกรรม',
        invoiceNumber: 'หมายเลขใบแจ้งหนี้',
        foreignOrderId: 'รหัสคำสั่งซื้อภายนอก',
        status: 'สถานะ',
        supplier: 'ซัพพลายเออร์',
        product: 'ผลิตภัณฑ์',
        cost: 'ต้นทุน',
        walletBalance: 'ยอดเงินคงเหลือในกระเป๋า',
        createdAt: 'สร้างเมื่อ',
        fulfilledAt: 'ดำเนินการเมื่อ',
        errorMessage: 'ข้อมูล Error',
      },
      filters: {
        transactionIdPlaceholder: 'รหัสธุรกรรม',
        invoiceNumberPlaceholder: 'หมายเลขใบแจ้งหนี้',
        foreignOrderRefsPlaceholder: 'ป้อน ref (กด Enter เพื่อเพิ่ม)',
      },
      suppliers: {
        alterra: 'Alterra',
        billfazz: 'Billfazz',
      },
      rowActions: {
        expandRow: 'ขยายแถว',
        collapseRow: 'ย่อแถว',
      },
      overview: {
        generalInfo: 'ข้อมูลทั่วไป',
        orderDetail: 'รายละเอียดคำสั่งซื้อ',
        notes: 'หมายเหตุ',
        destination: 'ปลายทาง',
        errorMessage: 'ข้อมูล Error',
        noErrorMessage: 'ไม่มีข้อมูล Error',
        errorCode: 'รหัส Error',
        vendorErrorCode: 'รหัส Error ผู้ขาย',
        vendorErrorMessage: 'ข้อมูล Error ผู้ขาย',
      },
    },
    aggregator: {
      empty: 'ไม่มีผลิตภัณฑ์ตัวรวมที่ตรงกับตัวกรองของคุณ',
      columns: {
        product: 'ผลิตภัณฑ์',
        sku: 'รหัส SKU',
        type: 'ประเภท',
        status: 'สถานะ',
        actions: 'การดำเนินการ',
        errorMessage: 'ข้อมูล Error',
        vendorCost: 'ต้นทุนการซื้อ',
      },
      type: {
        prepaid: 'เติมเงินล่วงหน้า',
        postpaid: 'รายเดือน',
      },
      filters: {
        productPlaceholder: 'ผลิตภัณฑ์',
        idPlaceholder: 'รหัส',
        available: 'พร้อมใช้งาน',
        unavailable: 'ไม่พร้อมใช้งาน',
      },
      status: {
        available: 'พร้อมใช้งาน',
        unavailable: 'ไม่พร้อมใช้งาน',
      },
      rowActions: {
        action: 'การดำเนินการ',
        edit: 'แก้ไข',
        enable: 'เปิดใช้งาน',
        disable: 'ปิดใช้งาน',
        expandRow: 'ขยายแถว',
        collapseRow: 'ย่อแถว',
      },
      statusModal: {
        disableTitle: 'ปิดใช้งานผลิตภัณฑ์?',
        enableTitle: 'เปิดใช้งานผลิตภัณฑ์?',
        disableConfirm: 'ปิดใช้งาน',
        enableConfirm: 'เปิดใช้งาน',
        cancel: 'ยกเลิก',
        warningTitle: 'คำเตือน',
        disableImpact:
          'เมื่อปิดใช้งานผลิตภัณฑ์นี้ ลูกค้าจะไม่สามารถซื้อได้จนกว่าจะเปิดใช้งานอีกครั้ง',
        disableSuccess: 'ปิดใช้งานผลิตภัณฑ์สำเร็จ',
        enableSuccess: 'เปิดใช้งานผลิตภัณฑ์สำเร็จ',
        disablePrompt: 'คุณแน่ใจหรือไม่ว่าต้องการปิดใช้งาน',
        enablePrompt: 'คุณแน่ใจหรือไม่ว่าต้องการเปิดใช้งาน',
        disableNote: 'ผลิตภัณฑ์จะยังคงปิดใช้งานจนกว่าจะเปิดใช้งานด้วยตนเองอีกครั้ง',
        enableNote: 'การดำเนินการนี้จะทำให้ผลิตภัณฑ์พร้อมสำหรับการดำเนินการ',
      },
      overview: {
        generalInfo: 'ข้อมูลทั่วไป',
        aggregatorInfo: 'ข้อมูลตัวรวม',
        name: 'ชื่อ',
        vendor: 'ผู้ขาย',
        vendorSku: 'SKU',
        priority: 'ลำดับความสำคัญ',
        procurementCost: 'ต้นทุนการซื้อ',
      },
      editModal: {
        title: 'แก้ไขผลิตภัณฑ์',
        saveChanges: 'บันทึกการเปลี่ยนแปลง',
        productInfo: 'ข้อมูลผลิตภัณฑ์',
        productName: 'ชื่อผลิตภัณฑ์',
        aggregatorMappings: 'การแมปตัวรวม',
        aggregatorColumn: 'ตัวรวม',
        updateSuccess: 'อัปเดตผลิตภัณฑ์สำเร็จ',
      },
    },
    productGroup: {
      empty: 'ไม่มีกลุ่มผลิตภัณฑ์ที่ตรงกับตัวกรองของคุณ',
      columns: {
        product: 'ผลิตภัณฑ์',
        price: 'ราคา',
        actions: 'การดำเนินการ',
      },
      actions: {
        import: 'นำเข้า',
        export: 'ส่งออก',
        newGroup: 'กลุ่มใหม่',
      },
      rowActions: {
        action: 'การดำเนินการ',
        edit: 'แก้ไข',
        editProduct: 'แก้ไขผลิตภัณฑ์',
        addChild: 'เพิ่มรายการย่อย',
        addPlanGroup: 'เพิ่มกลุ่มแพ็กเกจ',
        attachProduct: 'แนบผลิตภัณฑ์',
        changeOrder: 'เปลี่ยนลำดับ',
        detachProduct: 'ถอดผลิตภัณฑ์',
        enable: 'เปิดใช้งาน',
        disable: 'ปิดใช้งาน',
        delete: 'ลบ',
        expandRow: 'ขยายแถว',
        collapseRow: 'ย่อแถว',
      },
      modals: {
        createTitle: 'เพิ่มกลุ่มใหม่',
        editGroupTitle: 'แก้ไขกลุ่ม',
        changeOrderTitle: 'เปลี่ยนลำดับ',
        changeOrderEmpty: 'ไม่มีผลิตภัณฑ์ในกลุ่มนี้',
        saveChanges: 'บันทึกการเปลี่ยนแปลง',
        reorder: 'ลากเพื่อจัดลำดับ',
        orderSaved: 'บันทึกลำดับแล้ว',
        editProductTitle: 'แก้ไขผลิตภัณฑ์',
        attachTitle: 'แนบผลิตภัณฑ์',
        deleteTitle: 'ลบกลุ่ม',
        deleteProductTitle: 'ลบผลิตภัณฑ์',
        detachTitle: 'ถอดผลิตภัณฑ์',
        deletePrompt: 'คุณแน่ใจหรือไม่ว่าต้องการลบ "<bold>{{name}}</bold>"?',
        deleteProductPrompt: 'คุณแน่ใจหรือไม่ว่าต้องการลบ "<bold>{{name}}</bold>"?',
        deleteConfirm: 'ลบ',
        deleteNote: 'คุณไม่สามารถยกเลิกการดำเนินการนี้ได้',
        deleteImpact: 'การลบกลุ่มนี้จะนำรายการนี้ออกจากแคตตาล็อก ลูกค้าจะไม่เห็นรายการนี้อีก',
        detachPrompt: 'คุณแน่ใจหรือไม่ว่าต้องการถอด "<bold>{{name}}</bold>"?',
        groupInformation: 'ข้อมูลกลุ่ม',
        name: 'ชื่อ',
        namePlaceholder: 'กรอกชื่อ',
        nameRequired: 'ต้องระบุชื่อ',
        photo: 'รูป',
        groupType: 'ประเภทกลุ่ม',
        section: 'ส่วน',
        sectionPlaceholder: 'เลือกส่วน',
        sectionRequired: 'ต้องระบุส่วน',
        parentGroup: 'กลุ่มหลัก',
        parentPlaceholder: 'เลือกกลุ่มหลัก',
        hidden: 'ซ่อน',
        upload: 'อัปโหลด',
        changeImage: 'เปลี่ยนรูป',
        removeImage: 'ลบรูป',
        imageHint: '*ไฟล์<bold>รูป</bold>เท่านั้น (สูงสุด <bold>2MB</bold>)',
        imageTransparent:
          'ใช้รูปที่มี<bold>พื้นหลังโปร่งใส</bold> เพื่อให้เห็นพื้นเขียว',
        imageTypeError: 'รูปต้องเป็น JPG, PNG หรือ JPEG',
        imageSizeError: 'รูปต้องไม่เกิน 2 MB',
        types: {
          subgroup: 'กลุ่มย่อย',
          product: 'ผลิตภัณฑ์',
          esimCountry: 'ประเทศ ESIM',
        },
        sections: {
          dataPerDay: 'ข้อมูลต่อวัน',
          dataInTotal: 'ข้อมูลรวม',
        },
        save: 'บันทึกการเปลี่ยนแปลง',
        createGroup: 'สร้างกลุ่ม',
        cancel: 'ยกเลิก',
        yes: 'ใช่',
        no: 'ไม่',
        attach: 'แนบผลิตภัณฑ์',
        product: 'ผลิตภัณฑ์',
        products: 'ผลิตภัณฑ์',
        selectProduct: 'เลือกผลิตภัณฑ์',
        noProducts: 'ไม่พบผลิตภัณฑ์ที่ตรงกัน',
        loadingProducts: 'กำลังโหลดผลิตภัณฑ์…',
        attachLoadError: 'โหลดผลิตภัณฑ์ไม่สำเร็จ',
        productName: 'ชื่อผลิตภัณฑ์',
        price: 'ราคา',
        availability: 'ความพร้อมใช้งาน',
        available: 'พร้อมใช้งาน',
        notAvailable: 'ไม่พร้อมใช้งาน',
        productStatus: 'สถานะผลิตภัณฑ์',
        enabled: 'เปิดใช้',
        disabled: 'ปิดใช้',
        visibility: 'การมองเห็น',
        visible: 'แสดง',
        refundable: 'คืนเงินได้',
        productDisabled: 'ผลิตภัณฑ์ถูกปิดใช้',
        availableHint: 'สามารถซื้อสินค้าได้',
        notAvailableHint: 'ไม่สามารถซื้อสินค้าได้',
        visibleHint: 'แสดงในรายการ',
        hiddenHint: 'ซ่อนจากรายการ',
        enabledHint: 'สินค้าเปิดใช้งานและทำงานได้',
        disabledHint: 'สินค้าไม่ได้เปิดใช้งาน',
        refund: 'การคืนเงิน',
        nonRefundable: 'ไม่สามารถคืนเงินได้',
        refundableHint: 'สินค้ามีสิทธิ์ได้รับการคืนเงิน',
        nonRefundableHint: 'สินค้าไม่มีสิทธิ์ได้รับการคืนเงิน',
        locale: 'ภาษา',
        description: 'คำอธิบาย',
        descriptionPlaceholder: 'กรอกคำอธิบาย',
        rootParent: 'ไม่มี (ราก)',
        created: 'สร้างกลุ่มแล้ว',
        updated: 'อัปเดตกลุ่มแล้ว',
        productUpdated: 'อัปเดตผลิตภัณฑ์แล้ว',
        deleted: 'ลบ "{{name}}" แล้ว',
        productDeleted: 'ลบ "{{name}}" แล้ว',
        detached: 'ถอด "{{name}}" แล้ว',
        attached: 'แนบผลิตภัณฑ์แล้ว',
      },
      statusModal: {
        disableTitle: 'ปิดใช้งานผลิตภัณฑ์?',
        enableTitle: 'เปิดใช้งานผลิตภัณฑ์?',
        disableConfirm: 'ปิดใช้งาน',
        enableConfirm: 'เปิดใช้งาน',
        cancel: 'ยกเลิก',
        warningTitle: 'คำเตือน',
        disableImpact:
          'เมื่อปิดใช้งานผลิตภัณฑ์นี้ ลูกค้าจะไม่สามารถซื้อได้จนกว่าจะเปิดใช้งานอีกครั้ง',
        disableSuccess: 'ปิดใช้งานผลิตภัณฑ์สำเร็จ',
        enableSuccess: 'เปิดใช้งานผลิตภัณฑ์สำเร็จ',
        disablePrompt: 'คุณแน่ใจหรือไม่ว่าต้องการปิดใช้งาน',
        enablePrompt: 'คุณแน่ใจหรือไม่ว่าต้องการเปิดใช้งาน',
        disableNote: 'ผลิตภัณฑ์จะยังคงปิดใช้งานจนกว่าจะเปิดใช้งานด้วยตนเองอีกครั้ง',
        enableNote: 'การดำเนินการนี้จะทำให้ผลิตภัณฑ์พร้อมสำหรับการซื้ออีกครั้ง',
      },
    },
    productManagement: {
      empty: 'ไม่มีผลิตภัณฑ์ที่ตรงกับตัวกรองของคุณ',
      columns: {
        product: 'ผลิตภัณฑ์',
        priceScheme: 'รูปแบบราคา',
        schemes: {
          fixed: 'คงที่',
          per_account: 'ต่อบัญชี',
          user_defined: 'ผู้ใช้กำหนด',
        },
        price: 'ราคา',
        type: 'ประเภท',
        types: {
          unit: 'หน่วย',
          bundle: 'ชุด',
        },
        description: 'คำอธิบาย',
        status: 'สถานะ',
        actions: 'การดำเนินการ',
      },
      status: {
        available: 'พร้อมใช้งาน',
        unavailable: 'ไม่พร้อมใช้งาน',
        hidden: 'ซ่อน',
        disabled: 'ปิดใช้งาน',
      },
      actions: {
        import: 'นำเข้า',
        export: 'ส่งออก',
        changeOrder: 'เปลี่ยนลำดับ',
      },
      export: {
        title: 'ส่งออก',
        provider: 'ผู้ให้บริการ',
        allProviders: 'ผู้ให้บริการทั้งหมด',
        medium: 'สื่อ',
        allMediums: 'สื่อทั้งหมด',
        electronic: 'อิเล็กทรอนิกส์',
        voucherPin: 'Voucher PIN',
        supplier: 'ซัพพลายเออร์',
        allSuppliers: 'ซัพพลายเออร์ทั้งหมด',
        cancel: 'ยกเลิก',
        export: 'ส่งออก',
        exported: 'ส่งออกผลิตภัณฑ์แล้ว',
        failed: 'ส่งออกไม่สำเร็จ',
        stillProcessing: 'กำลังประมวลผลการส่งออก',
        unitHint: 'ไฟล์มีเฉพาะสินค้าแบบหน่วย',
      },
      changeOrder: {
        title: 'เปลี่ยนลำดับ',
        provider: 'ผู้ให้บริการ',
        selectProvider: 'เลือกผู้ให้บริการ',
        cancel: 'ยกเลิก',
        saveChanges: 'บันทึกการเปลี่ยนแปลง',
        saved: 'บันทึกลำดับผลิตภัณฑ์ {{provider}} แล้ว',
      },
      import: {
        title: 'นำเข้าไฟล์',
        uploadData: 'อัปโหลดข้อมูล',
        downloadTemplate: 'ดาวน์โหลด<template>เทมเพลต</template>เพื่อดูตัวอย่างรูปแบบที่ต้องการ',
        dropHint: 'คลิกหรือลากไฟล์มาที่นี่เพื่ออัปโหลด',
        singleFile: 'อัปโหลดได้เพียงไฟล์เดียว',
        formats: 'รองรับไฟล์: XLSX, XLS, และ CSV.',
        cancel: 'ยกเลิก',
        upload: 'อัปโหลด',
        data: 'ข้อมูล',
        status: 'สถานะ',
        errorDetails: 'รายละเอียดข้อผิดพลาด',
        valid: 'ถูกต้อง',
        invalid: 'ไม่ถูกต้อง',
        missingColumn: 'ไม่มีคอลัมน์',
        successNote: 'จะอัปโหลดเฉพาะแถวที่สำเร็จเท่านั้น',
        invalidType: 'กรุณาอัปโหลดไฟล์ XLSX',
        imported: 'นำเข้าสินค้าแล้ว',
        started: 'เริ่มนำเข้าแล้ว',
        failed: 'นำเข้าไม่สำเร็จ',
        skipped: 'ข้าม {{count}} แถว',
        stillProcessing: 'กำลังประมวลผลการนำเข้า',
        row: 'แถว',
        field: 'ฟิลด์',
        message: 'ข้อความ',
        summary: 'เขียน {{written}} รายการ ข้าม {{skipped}}',
        logNote: 'ตรวจสอบแถวที่ไม่ได้ถูกเขียน',
        noneValid: 'ไม่มีคอลัมน์ที่ถูกต้องสำหรับนำเข้า',
        columns: {
          id: 'ID',
          name: 'ชื่อ',
          fapiao_name: 'ชื่อ Fapiao',
          medium: 'สื่อ',
          price: 'ราคา',
          reference_cost_price: 'ราคาทุน',
          price_scheme: 'รูปแบบราคา',
          supplier_product_code: 'รหัสสินค้าซัพพลายเออร์',
          denomination_currency: 'สกุลเงินมูลค่า',
          denomination: 'มูลค่า',
          type: 'ประเภท',
        },
      },
      rowActions: {
        action: 'การดำเนินการ',
        setInstruction: 'ตั้งค่าคำแนะนำ',
        edit: 'แก้ไข',
        enable: 'เปิดใช้งาน',
        disable: 'ปิดใช้งาน',
      },
      instruction: {
        title: 'ตั้งค่าคำแนะนำ',
        locale: 'ภาษา',
        instruction: 'คำแนะนำ',
        placeholder: 'กรอกคำแนะนำ',
        add: 'เพิ่มคำแนะนำ',
        remove: 'ลบคำแนะนำ',
        cancel: 'ยกเลิก',
        saveChanges: 'บันทึกการเปลี่ยนแปลง',
        saved: 'บันทึกคำแนะนำแล้ว',
      },
      edit: {
        title: 'แก้ไขผลิตภัณฑ์',
        photoLabel: 'รูปภาพ',
        cancel: 'ยกเลิก',
        back: 'กลับ',
        next: 'ถัดไป',
        saveChanges: 'บันทึกการเปลี่ยนแปลง',
        saved: 'อัปเดตผลิตภัณฑ์แล้ว',
        photo: 'รูป',
        uploadTitle: 'อัปโหลดรูปภาพ',
        uploadSave: 'บันทึก',
        name: 'ชื่อ',
        description: 'คำอธิบาย',
        descriptionPlaceholder: 'กรอกคำอธิบาย',
        locale: 'ภาษา',
        imageHint: '*ไฟล์<bold>รูป</bold>เท่านั้น (สูงสุด <bold>2MB</bold>)',
        imageTransparent: 'ใช้รูป<bold>พื้นหลังโปร่งใส</bold> เพื่อให้เห็นพื้นเขียว',
        steps: {
          info: 'ข้อมูลผลิตภัณฑ์',
          details: 'รายละเอียดผลิตภัณฑ์',
          visibility: 'การมองเห็นและการเข้าถึง',
        },
        pricing: 'ราคา',
        priceScheme: 'รูปแบบราคา',
        priceCurrency: 'สกุลเงินราคา',
        price: 'ราคา',
        priceBundleHint: 'ราคานี้ตามชุดสินค้า เปลี่ยนได้ที่ราคาในชุด',
        referenceCostCurrency: 'สกุลเงินต้นทุนอ้างอิง',
        referenceCostPrice: 'ราคาต้นทุนอ้างอิง',
        denominationCurrency: 'สกุลเงินมูลค่าหน้า',
        denomination: 'มูลค่าหน้า',
        productDetails: 'รายละเอียดผลิตภัณฑ์',
        medium: 'รูปแบบ',
        type: 'ประเภท',
        supplierProductCode: 'รหัสผลิตภัณฑ์ซัพพลายเออร์',
        productBundle: 'ชุดผลิตภัณฑ์',
        bundleSearch: 'เช่น IF หรือ IF 50 NT',
        bundleCount: '{{count}} รายการ',
        total: 'รวม',
        availability: 'ความพร้อมใช้งาน',
        available: 'พร้อมใช้งาน',
        availableHint: 'สามารถซื้อสินค้าได้',
        notAvailable: 'ไม่พร้อมใช้งาน',
        notAvailableHint: 'ไม่สามารถซื้อสินค้าได้',
        productStatus: 'สถานะผลิตภัณฑ์',
        enabled: 'เปิดใช้',
        enabledHint: 'สินค้าใช้งานได้',
        disabled: 'ปิดใช้',
        disabledHint: 'สินค้าไม่ทำงาน',
        visibility: 'การมองเห็น',
        visible: 'แสดง',
        visibleHint: 'แสดงในรายการ',
        hidden: 'ซ่อน',
        hiddenHint: 'ซ่อนจากรายการ',
        access: 'การเข้าถึง',
        publicAccess: 'การเข้าถึงสาธารณะ',
        publicAccessHint: 'แสดงต่อผู้ใช้ทุกคน',
        restrictedAccess: 'การเข้าถึงแบบจำกัด',
        restrictedAccessHint: 'แสดงต่อผู้ใช้บางส่วน',
        refundable: 'คืนเงินได้',
        schemes: { fixed: 'คงที่', per_account: 'ต่อบัญชี', user_defined: 'ผู้ใช้กำหนด' },
        mediums: { voucher_pin: 'PIN บัตรกำนัล', electronic: 'อิเล็กทรอนิกส์' },
        types: { unit: 'หน่วย', bundle: 'ชุด' },
        bundleColumns: {
          product: 'ผลิตภัณฑ์',
          qty: 'จำนวน',
          price: 'ราคา',
          subtotal: 'รวมย่อย',
          action: 'การดำเนินการ',
        },
      },
    },
    productFee: {
      description: 'จับคู่สื่อสินค้า ซัพพลายเออร์ หรือทั้งสองอย่าง ค่าธรรมเนียมแบบเปอร์เซ็นต์สามารถรวมในการคำนวณค่าธรรมเนียมการชำระเงินได้',
      summary: '{{count}} กฎ',
      empty: 'ยังไม่มีกฎค่าธรรมเนียมสินค้า',
      anyMedium: 'ทุกสื่อ',
      anySupplier: 'ทุกซัพพลายเออร์',
      yes: 'ใช่',
      no: 'ไม่',
      actions: {
        create: 'สร้างกฎค่าธรรมเนียม',
        edit: 'แก้ไข',
        save: 'บันทึก',
        delete: 'ลบ',
      },
      columns: {
        name: 'ชื่อ',
        currency: 'สกุลเงิน',
        products: 'สินค้า',
        fee: 'ค่าธรรมเนียม',
        paymentBasis: 'ฐานค่าธรรมเนียมการชำระเงิน',
        refundable: 'คืนเงินได้',
        status: 'สถานะ',
        action: 'การทำงาน',
      },
      status: {
        enabled: 'เปิดใช้งาน',
        disabled: 'ปิดใช้งาน',
      },
      medium: {
        voucher_pin: 'Voucher PIN',
        electronic: 'อิเล็กทรอนิกส์',
        esim: 'eSIM',
        simcard: 'ซิมจริง',
      },
      scheme: {
        fixed: 'คงที่',
        percentage: 'เปอร์เซ็นต์',
      },
      form: {
        createTitle: 'สร้างกฎค่าธรรมเนียมสินค้า',
        editTitle: 'แก้ไข {{name}}',
        name: 'ชื่อ',
        fapiao: 'ชื่อ Fapiao',
        scheme: 'รูปแบบค่าธรรมเนียม',
        currency: 'สกุลเงิน',
        products: 'รหัสสินค้า',
        fee: 'ค่าธรรมเนียม',
        percentageMax: 'ค่าธรรมเนียมแบบเปอร์เซ็นต์ต้องไม่เกิน 100',
        paymentBasis: 'รวมในฐานค่าธรรมเนียมการชำระเงิน',
        paymentBasisHint: 'เปิด: ค่าธรรมเนียมนี้รวมในเปอร์เซ็นต์การชำระเงิน\nปิด: คำนวณจากราคาสินค้าเท่านั้น\nค่าธรรมเนียมคงที่รวมไม่ได้',
        refundable: 'คืนเงินได้',
        refundableHint: 'ค่าธรรมเนียมนี้คืนได้',
        enabled: 'เปิดใช้งาน',
        enabledHint: 'กฎนี้ใช้งานอยู่',
        localizedNames: 'ชื่อตามภาษา',
        localizedPlaceholder: 'ชื่อในภาษานี้',
        matchRequired: 'เลือกสื่อหรือซัพพลายเออร์ กฎต้องมีอย่างน้อยหนึ่งอย่าง',
        savedCreate: 'สร้างกฎค่าธรรมเนียมสินค้าแล้ว',
        savedUpdate: 'อัปเดตกฎค่าธรรมเนียมสินค้าแล้ว',
        deleteTitle: 'ลบกฎค่าธรรมเนียมนี้?',
        deleteBody: 'ลบ {{name}}? สินค้าจะไม่ใช้ค่าธรรมเนียมนี้อีก',
        deleted: 'ลบกฎค่าธรรมเนียมสินค้าแล้ว',
      },
    },
    manageSku: {
      searchPlaceholder: 'ค้นหาด้วยรหัสหรือชื่อ SKU',
      empty: 'ไม่มี SKU',
      yes: 'ใช่',
      no: 'ไม่',
      actions: { create: 'สร้าง SKU' },
      filters: {
        status: 'สถานะ',
        enabled: 'เปิดใช้งาน',
        disabledOnly: 'ปิดใช้งาน',
        recallable: 'เรียกคืนได้',
        recallableYes: 'เรียกคืนได้',
        recallableNo: 'เรียกคืนไม่ได้',
        legacyProductId: 'รหัสสินค้าเดิม',
      },
      columns: {
        code: 'รหัส SKU',
        name: 'ชื่อ',
        identifier: 'ตัวระบุ',
        pinFormat: 'รูปแบบ PIN',
        lowStock: 'สต็อกต่ำ',
        recallable: 'เรียกคืนได้',
        status: 'สถานะ',
        legacyProducts: 'สินค้าเดิม',
        action: 'การดำเนินการ',
      },
      status: { enabled: 'เปิดใช้งาน', disabled: 'ปิดใช้งาน' },
      overview: {
        generalInfo: 'ข้อมูลทั่วไป',
        createdAt: 'สร้างเมื่อ',
        updatedAt: 'อัปเดตเมื่อ',
      },
      rowActions: { action: 'การดำเนินการ', edit: 'แก้ไข', expandRow: 'ขยายแถว', collapseRow: 'ย่อแถว' },
      form: {
        createTitle: 'สร้าง SKU',
        editTitle: 'แก้ไข SKU',
        code: 'รหัส SKU',
        name: 'ชื่อ',
        pinFormat: 'รูปแบบ PIN',
        pinFormatHint: 'รูปแบบ RE2 ไม่สนใจตัวพิมพ์เล็กใหญ่ เว้นว่างหากไม่ตรวจรูปแบบ',
        lowStock: 'เกณฑ์สต็อกต่ำ',
        restockDelay: 'ระยะเวลารอเติมสต็อก (วัน)',
        legacyProducts: 'รหัสสินค้าเดิม',
        legacyProductsHint: 'รหัสสินค้า Laravel การบันทึกจะแทนที่รายการทั้งหมด',
        disabled: 'ปิดใช้งาน',
        recallable: 'เรียกคืนได้',
        codeRequired: 'ต้องระบุรหัส SKU',
        nameRequired: 'ต้องระบุชื่อ',
        invalidLegacyId: 'กรอกรหัสสินค้าเป็นจำนวนเต็มบวก',
        create: 'สร้าง',
        save: 'บันทึก',
        created: 'สร้าง SKU แล้ว',
        updated: 'อัปเดต SKU แล้ว',
        notFound: 'ไม่พบ SKU',
        saveFailed: 'บันทึก SKU ไม่สำเร็จ',
      },
    },
    wallet: {
      average_spending_per_day: 'ค่าใช้จ่ายเฉลี่ยต่อวัน',
      history: 'ประวัติยอดเงินคงเหลือ',
      chart_balance: 'ยอดคงเหลือ',
      chart_change: 'การเปลี่ยนแปลง',
      columns: {
        provider: 'ผู้ให้บริการ',
      },
    },
    voucherPinImport: {
      title: 'นำเข้า Voucher PIN',
      search: 'ค้นหารหัสหรือชื่อ SKU',
      skuId: 'รหัส SKU',
      status: 'สถานะ',
      template: 'ดาวน์โหลดเทมเพลต',
      uploadButton: 'อัปโหลดไฟล์',
      empty: 'ไม่มีชุดนำเข้า',
      ownBatches: 'แสดงเฉพาะชุดที่คุณสร้าง',
      columns: {
        batch: 'ชุด',
        sku: 'SKU',
        file: 'ไฟล์',
        source: 'แหล่งที่มา',
        status: 'สถานะ',
        cost: 'ต้นทุน',
        rows: 'ประมวลผลแล้ว',
        errors: 'ข้อผิดพลาด',
        accepted: 'รับแล้ว',
        createdAt: 'สร้างเมื่อ',
        action: 'การทำงาน',
      },
      statuses: {
        uploaded: 'อัปโหลดแล้ว',
        ready: 'พร้อม',
        preflight_failed: 'ตรวจสอบไม่ผ่าน',
        committed: 'บันทึกแล้ว',
        failed: 'ล้มเหลว',
        cancelled: 'ยกเลิก',
        expired: 'หมดอายุ',
      },
      actions: { view: 'ดู', commit: 'ยืนยัน', cancel: 'ยกเลิก' },
      rowActions: { expandRow: 'ขยายแถว', collapseRow: 'ย่อแถว' },
      overview: { generalInfo: 'ข้อมูลทั่วไป' },
      confirm: {
        commitTitle: 'ยืนยันชุดนี้?',
        commitBody: 'รหัส PIN ที่พร้อมจะถูกบันทึกเข้าสต็อก',
        cancelTitle: 'ยกเลิกชุดนี้?',
        cancelBody: 'ชุดนี้จะไม่ถูกนำเข้า',
        yes: 'ใช่',
        no: 'ไม่',
      },
      upload: {
        title: 'อัปโหลดไฟล์ PIN',
        hint: 'ไฟล์ต้องเป็น .xlsx หรือ .csv และมีหัวคอลัมน์ pin_code',
        skuId: 'รหัส SKU',
        drop: 'วางไฟล์ .xlsx หรือ .csv ที่นี่',
        costPrice: 'ราคาทุน',
        currency: 'สกุลเงิน',
        autoCommit: 'ยืนยันอัตโนมัติเมื่อตรวจสอบผ่าน',
        cancel: 'ยกเลิก',
        submit: 'อัปโหลด',
        skuRequired: 'กรอกรหัส SKU ที่มีอยู่',
        fileRequired: 'เลือกไฟล์ .xlsx หรือ .csv',
        costInvalid: 'ต้นทุนต้องเป็นทศนิยมไม่เกิน 4 ตำแหน่ง เช่น 142.5000',
        currencyInvalid: 'สกุลเงินต้องเป็นตัวอักษร 3 ตัว เช่น TWD',
        failed: 'ไม่รับไฟล์นี้',
      },
      detail: {
        title: 'ชุดนำเข้า',
        close: 'ปิด',
        loading: 'กำลังโหลดชุด...',
        missing: 'โหลดชุดนี้ไม่ได้',
        row: 'แถว',
        stage: 'ขั้นตอน',
        message: 'ข้อความ',
        noLogs: 'ยังไม่มีบันทึก',
        logs: 'บันทึก',
      },
    },
  },
};
